import React, { useState } from 'react';

import {
  Flex, Text, Image, FlexProps, Spinner,
} from '@chakra-ui/react';
import dayjs from 'dayjs';
import { useMutation } from 'react-query';

import api from 'api';
import { Icon } from 'components';
import ZoomImage from 'containers/Modals/ZoomImage';
import { InfoRow } from 'containers/Texts';
import { ContentRoutes } from 'enums/routes';

interface CNHCardProps extends FlexProps{
    ImageUrlName?: string
    label?: string
    user: User
    mutate: () => void
    documentName?: string
    dueDateName?: string
}

export default function DocumentCard(
  {
    ImageUrlName,
    documentName,
    dueDateName,
    user,
    label,
    mutate: refetch,
    ...rest
  }:CNHCardProps) {
  const [image, setImage] = useState<string>();
  const { mutate, isLoading } = useMutation(() => api().put(`/${ContentRoutes.Users}/${user.id}`, {
    [ImageUrlName]: 'null',
  }), {
    onSuccess: () => {
      refetch();
    },
  });

  return (
    <Flex
      flex={1}
      flexDir="column"
      {...rest}>
      <Text variant="xLargeBold">{label}</Text>
      <Flex
        justifyContent="space-between"
        mt={2}
        backgroundColor="white.default"
        borderRadius={8}
        p={3}>
        <Flex>
          <ZoomImage
            isOpen={!!image}
            onClose={() => setImage(undefined)}
            data={image}
          />
          <Image
            onClick={() => setImage(user[ImageUrlName])}
            width="72px"
            heigth="72px"
            src={user[ImageUrlName] ?? '/images/image-placeholder.png'}
          />
          <Flex
            ml={4}
            justifyContent="center"
            flexDir="column">
            <Text variant="smallRegular">{user[documentName] || 'N/A'}</Text>
            <InfoRow
              label="Validade:"
              value={user[dueDateName] ? dayjs(user[dueDateName]).format('DD/MM/YYYY') : 'N/A'}
            />
          </Flex>
        </Flex>
        {!isLoading ? (
          <Flex
            onClick={() => mutate()}
            color="gray.700"
            alignItems="center">
            <Icon name="trash-alt" />
          </Flex>
        ) : <Spinner />}
      </Flex>
    </Flex>
  );
}
